export default __webpack_public_path__ + "static/card2-desktop-9cd67b5f6e373f74ca99c9ddae54a18d.png";